import React, {type ReactNode, useEffect} from "react";
import {type ForwardRefComponent, type HTMLMotionProps, motion, useAnimation, type Variants,} from "framer-motion";
import {useInView} from "react-intersection-observer";

interface Props {
  children: ReactNode;
  variant: Variants;
  styles?: string;
  Element?:
    | ForwardRefComponent<HTMLDivElement, HTMLMotionProps<"div">>
    | ForwardRefComponent<HTMLSpanElement, HTMLMotionProps<"span">>
    | ForwardRefComponent<HTMLButtonElement, HTMLMotionProps<"button">>;
}

export default function InViewWrapper({
                                        children,
                                        variant,
                                        styles,
                                        Element = motion.div,
                                      }: Props) {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      void controls.start("visible").catch();
    }
  }, [controls, inView]);

  return (
    <Element
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={variant}
      className={styles ?? ""}
    >
      {children}
    </Element>
  );
}
